import { useState, useEffect } from "react";
import { MOBILE_WIDTH } from "@/resources/constants";
import styles from "@/styles/components/videoWall.module.scss";

interface Props {
    type?: string;
    videos: any;
}

interface VideoItemProps {
    videoUrl: any;
}

function VideoItem({videoUrl}: VideoItemProps){

    return(
        <div className={styles.videoItemDiv}>
            <video
                src={videoUrl}
                //controls // Shows play/pause, volume, etc.
                muted    // **IMPORTANT**: Most browsers block autoplay unless it's muted
                autoPlay
                loop
                playsInline // Important for playback on iOS
                width="100%"
                height="100%"
                />
        </div>
    );
}

export default function VideoWall({type, videos}: Props){

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_WIDTH); // Adjust the width threshold as needed
        };

        handleResize(); // Check on initial render
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    function getLightEffectClass(){
        if(type === "retail")
            return "light_effect_card_retail";
        else if(type === "transportation")
            return "light_effect_card_transport";
        else if(type === "industries")
            return "light_effect_card_industry";
        return "light_effect_card";
    }

    return(
        <div className = {styles.rootDiv}>
            {
                isMobile ? 
                <div className = {styles.videoWallMobile}>
                    {videos.flat().map((item: any, index: number) => (
                        <div
                            key={index}
                            className={`${styles.videoWallItem} ${getLightEffectClass()}`}>
                            <VideoItem videoUrl={item} />
                        </div>
                    ))}
                </div>
                :
                <div className = {styles.videoWall}>
                    {videos.map((videosRow: any, videosRowIndex: number) => (
                        <div
                            key = {videosRowIndex}
                            className = {styles.videoWallRow}>
                            {videosRow.map((item: any, index: number) => (
                                <div
                                    key = {index}
                                    className = {`${styles.videoWallItem} ${getLightEffectClass()}`}>
                                    <VideoItem videoUrl = {item} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            }
        </div>
    )
}